import { getSocialConfig } from './socialConfig';

import * as S from './SocialButtons.styles';

export type SocialButtonsProps = {
  subject?: string;
  title: string;
  url: string;
};

export const SocialButtons = ({ subject, title, url }: SocialButtonsProps) => {
  return (
    <S.Container>
      {getSocialConfig(url, title, subject).map((social) => {
        // need to disable typechecking here since library doesn't support this optimization
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const Component = social.component as any;
        const Icon = social.icon;
        return (
          <S.Wrapper key={social.provider}>
            <Component {...social.props}>
              <Icon />
            </Component>
          </S.Wrapper>
        );
      })}
    </S.Container>
  );
};

SocialButtons.displayName = 'SocialButtons';
